import store from '@/store'
import sortFilters from './sortFilters'

export default function createNewDynamicFiltersList([add, filterKey]) {
  const state = store.state.vacancies
  let filters = state.dynamicRouteFilters

  if (add) {
    filters = [...filters]
    filters.push(filterKey)
  } else {
    filters = filters.filter(key => key !== filterKey)
  }

  filters = sortFilters(state.dynamicFilters, filters)
  filters = filters.join('-')

  return filters
}
